import ShopIconDark from 'assets/images/icons/dark - shop.svg?react';
import ShopIconSimpleFiligree from 'assets/images/icons/simple filigree - shop.svg?react';
import ShopIconSpringVibes from 'assets/images/icons/spring - shop.svg?react';
import ShopIconVickyBaumannBoho from 'assets/images/icons/vicky boho - shop.svg?react';
import ShopIconVickyBaumannFineart from 'assets/images/icons/vicky fineart - shop.svg?react';
import { IIconProps } from 'types/icons';
import { BaseIcon } from './BaseIcon';
import { SetIcon } from './SetIcon';
import { useTemplateVariant } from 'hooks/useTemplateVariant';

const LegacyShopIcon = (props: IIconProps) =>
  useTemplateVariant({
    classic: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />,
    dark: () => <BaseIcon icon={ShopIconDark} {...props} />,
    simpleFiligree: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />,
    springVibes: () => <BaseIcon icon={ShopIconSpringVibes} {...props} />,
    vickyBaumannBoho: () => <BaseIcon icon={ShopIconVickyBaumannBoho} {...props} />,
    vickyBaumannFineart: () => <BaseIcon icon={ShopIconVickyBaumannFineart} {...props} />,
    breeze: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />,
    capri: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />,
    rose: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />,
    calm: () => <BaseIcon icon={ShopIconSimpleFiligree} {...props} />
  })();

export const ShopIcon = (props: IIconProps) => (
  <SetIcon slug="cart" fallback={LegacyShopIcon} {...props} />
);
